import * as React from 'react';
import { observer } from 'mobx-react';
import CommentInputStore from './store';
import { injectStore } from '../../components/common/rootStore';
import { ICommentCreateData, ICustomEvent } from 'uciflow';
if (process.env.BROWSER) {
    require('./commentInput.less');
}

export interface ICommentInputProp {
    commentInputStore?: CommentInputStore;
}

// @injectStore({
//     commentInputStore: CommentInputStore,
// })
// @observer
export default class CommentInput extends React.Component<ICommentInputProp> {

    public render(): JSX.Element {
        return <>
        </>;
    }

    public componentDidMount = () => {
        document.addEventListener('comment:create', this.onCommentCreate);
        this.props.commentInputStore.init();
    }

    public componentWillUnmount = () => {
        document.removeEventListener('comment:create', this.onCommentCreate);
    }

    private onCommentCreate = (event: ICustomEvent<ICommentCreateData>) => {
        console.log('create');
        try {
            const store = this.props.commentInputStore;
            const eventData = event.data;
            if (eventData.type === 0) {
                store.addCommentItem(eventData).catch((ex) => {
                   // todo
                });
            } else if (eventData.type === 1) {
                store.addReplyItem(eventData).catch((ex) => {
                   // todo
                });
            }
        } catch (ex) {
            // todo
        }
    }
}
